import { lazy } from 'react';

const LoadableReportSpamDoneModal = lazy(
  () => import(/* webpackChunkName: "damz-modals" */ './ReportSpamDoneModal')
);

export default LoadableReportSpamDoneModal;
